import api from '@pray/shared/utils/api';

import type { WorkflowVersionResponse } from './data/response';

type GetVersionParams = {
  artistId: string;
  workflowId: string;
  versionNumber: number | 'draft';
};

async function getVersion({ artistId, workflowId, versionNumber }: GetVersionParams) {
  const url = `/web/studio/artists/${artistId}/workflows/${workflowId}/versions/${versionNumber}`;

  const response = await api.executeGetRequest<WorkflowVersionResponse>(url);

  if (!response || !response.data) {
    throw new Error('Failed to fetch workflow version');
  }

  return response.data;
}

export default getVersion;
export { getVersion };
